import { Formik, FormikConfig } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useGetMarginExportCsv } from "../../api/useGetMarginExportCsv";
import { CallsAlertsSearchBarValues } from "../../types";
import buildAndCleanQueryString from "../../utils/buildAndCleanQueryString";
import formatGetCallQueryString from "../../utils/formatGetCallQueryString";
import { formatUrlParamsToFormik } from "../../utils/formatUrlParamsToFormik";
import validationSchema from "../CallsAlertsSearchBar/SearchBarValidationSchema";
import ExportToolSearchBar from "./ExportToolSearchBar";

const SearchBarWrapper = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchFromState, setSearchState] = useState(validationSchema.cast({}));

  // Sets initial form state from URL
  useEffect(() => {
    const hasParams = searchParams.toString().length > 0;
    if (hasParams) {
      const searchStateFromQueryParams = formatUrlParamsToFormik(searchParams, {
        removeDashes: [
          "fromTradeDate",
          "toTradeDate",
          "fromDueDate",
          "toDueDate",
        ],
        returnAsArray: ["callType", "correspondentCode", "eventName"],
      });
      setSearchState(validationSchema.cast(searchStateFromQueryParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { refetch: fetchCsv, isFetching } = useGetMarginExportCsv(
    formatGetCallQueryString({
      searchParams,
    })
  );

  const handleClear = () => {
    setSearchState(validationSchema.cast({}));
    setSearchParams("");
  };

  const onSubmit = (values: CallsAlertsSearchBarValues) => {
    const queryString = buildAndCleanQueryString(values, {
      replaceSlashes: ["fromTradeDate", "toTradeDate"],
    });
    setSearchParams(`${queryString}&type=csv`);

    fetchCsv();
  };

  const formikConfig: FormikConfig<CallsAlertsSearchBarValues> = {
    initialValues: searchFromState as CallsAlertsSearchBarValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  };

  return (
    <Formik {...formikConfig}>
      {formikProps => {
        withFormikDevtools(formikProps);
        return (
          <ExportToolSearchBar onClear={handleClear} isFetching={isFetching} />
        );
      }}
    </Formik>
  );
};

export default SearchBarWrapper;
